<div class="record-list">
  <div class="row list-title">
    <div class="col-xs-6">
      <h3>{{label}}</h3>
    </div>
    <div class="col-xs-6 text-right">
      <a (click)="onHideShowRecordsList()" class="btn btn-expand">
        <em class="fa fa-plus" [ngClass]="{'fa-plus': !isShowList, 'fa-minus': isShowList}"></em>
      </a>
    </div>
  </div>

  <app-record-list [isShowList]="isShowList" [propostas]="propostas"></app-record-list>
</div>
